'use strict';

var ImportCsvErrorLogDirective = function ImportCsvErrorLogDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/import-csv-error-log.html'),
    controller: 'ImportCsvErrorLogController'
  };
};
ImportCsvErrorLogDirective.$inject = [];
module.exports = ImportCsvErrorLogDirective;